var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrinter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 5H16V0H4V5H3C1.346 5 0 6.346 0 8V15C0 16.103 0.897 17 2 17H4V20H16V17H18C19.103 17 20 16.103 20 15V8C20 6.346 18.654 5 17 5ZM6 2H14V5H6V2ZM14 18H6V14H14V18ZM18 15H16V12H4V15H2V8C2 7.449 2.449 7 3 7H17C17.552 7 18 7.449 18 8V15Z",
    fill: "#637381"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinter);
export default __webpack_public_path__ + "static/media/printer.778e1cd575820b2e4ca77d07a765dcd7.svg";
export { ForwardRef as ReactComponent };